<label for="feature_{{feature.id}}">
  {{ feature.header }}<span *ngIf="feature.unitHeader">, {{ feature.unitHeader }}</span>
  <span *ngIf="isRequired()"> *</span>
  <span *ngIf="feature.comment" nbTooltip="{{feature.comment}}"><nb-icon icon="bulb-outline"></nb-icon></span>
</label>

<div class="accordion-item__right" [ngClass]="isTextArea ? 'new' : ''">
  <form [formGroup]="form" style="width: 100%;">
    <input nbInput
           #inputTextArea
           type="text"
           fullWidth
           fieldSize="medium"
           [placeholder]="valueExample ? valueExample : 'Текстовое значение'"
           formControlName="featureValue"
           *ngIf="!isTextArea"
    />

    <textarea class="input-text-area" [ngClass]="isLongContent && trimString === true ? 'show' : 'hide'"
              #inputTextArea
              nbInput
              type="text"
              fullWidth
              fieldSize="medium"
              [placeholder]="valueExample ? valueExample : 'Текстовое значение'"
              formControlName="featureValue"
              *ngIf="isTextArea"
              (input)="resizeOnTextAreaInput($event)"
    ></textarea>
    <div *ngIf="featureValue.invalid && (featureValue.dirty || featureValue.touched)">
      <div *ngIf="featureValue.hasError('required')" class="text-danger" i18n="@@FeatureValueRequiredError">
        Поле обязательно для заполнения
      </div>
      <div *ngIf="featureValue.hasError('pattern')" class="text-danger" i18n="@@FeatureValueIncorrectPatternError">
        Не корректное значение
      </div>
      <div *ngIf="featureValue.hasError('url')" class="text-danger" i18n="@@FeatureValueUrlError">
        Не корректное значение адреса
      </div>
      <div *ngIf="featureValue.hasError('email')" class="text-danger" i18n="@@FeatureValueEmailError">
        Не корректное значение адреса электронной почты
      </div>
      <div *ngIf="featureValue.hasError('minlength')" class="text-danger" i18n="@@FeatureValueMinLengthError">
        Минимум {{ featureValue.errors.minlength.requiredLength }} символов
      </div>
      <div *ngIf="featureValue.hasError('maxlength')" class="text-danger" i18n="@@FeatureValueMaxLengthError">
        Превышен лимит символов: {{ featureValue.errors.maxlength.actualLength }}
        из {{ featureValue.errors.maxlength.requiredLength }}
      </div>

      <div *ngIf="featureValue.hasError('stringContent')">
        <div [ngClass]="featureValue.errors.stringContent.hasNotNumber ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotNumberError" *ngIf="customValidator.useDigits">
          Поле должно содержать хотя бы 1 цифру!
        </div>
        <div [ngClass]="featureValue.errors.stringContent.hasNotCharacters ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotCharactersError" *ngIf="customValidator.useCharacters">
          Поле должно содержать хотя бы 1 букву ({{ featureValue.errors.stringContent.allowedAlphabets.join(', ') }}) ({{ featureValue.errors.stringContent.allowedCharactersCases.join(', ') }})
        </div>
        <div [ngClass]="featureValue.errors.stringContent.hasNotSymbols ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasNotSymbolsError" *ngIf="customValidator.useCharacters">
          Поле должно содержать хотя бы 1 символ ({{ featureValue.errors.stringContent.allowedSymbols.join(', ') }})!
        </div>
        <div [ngClass]="featureValue.errors.stringContent.hasOtherSymbols ? 'text-danger' : 'text-success'" i18n="@@FeatureValueHasOtherSymbolsError">
          Поле не должно содержать других символов
        </div>
      </div>

    </div>
  </form>
  <div class="accordion-item__right-info">
    <div class="item">
      <div class="state-warn" *ngIf="featureValue.valid && isShowEmptyWarning()">
        <nb-icon icon="alert-triangle-outline"/>
      </div>
      <div class="state-err" *ngIf="featureValue.invalid">
        <nb-icon icon="alert-circle-outline"/>
      </div>
      <div class="state-success" *ngIf="featureValue.valid && !isEmpty()">
        <nb-icon icon="checkmark-outline"/>
      </div>

      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
         class="entityID"
         target="_blank"
         i18n-nbTooltip="@@OpenFeatureInNewWindow"
         nbTooltip="Открыть характеристику в новом окне"
         *ngIf="featureLink">
        #{{ feature.featureId }}
      </a>
    </div>

    <div *ngIf="isTextArea" class="item show-block" (click)="toggleTextarea();" [ngClass]="isLongContent && trimString === false ? '' : 'hide'">
      <p *ngIf="isLongContent && trimString">Подробнее</p>
      <p *ngIf="isLongContent && !trimString">Скрыть</p>
      <img class="ar-more" *ngIf="isLongContent" src="/assets/images/ar-more.svg" width="24" height="24" alt="">
    </div>
  </div>
</div>
